
export const GET_NORMATIVE = '/bcn';
export const GET_RESTRICTIONS_BY_NMBAHIA = '/directemar/bahia';
export const GET_RESTRICTIONS_BY_NMCAPITANIA = '/directemar/restrictions';
export const GET_LIST_NMBAHIA = '/directemar/nmbahia';
export const GET_LIST_NMCAPITANIA = '/directemar/nmcapitania ';
export const GET_CONCESSION = '/subpesca/concessions';
export const GET_RISKS_MASTER = '/intesal/risks/master';
export const DATA_PROVIDERS_GET_INTESAL_COORDS = '/intesal/coords';
export const DATA_PROVIDERS_GET_RILES_COORDS = '/riles/rpm/';
export const GET_POLYGONS_SUBPESCA = '/subpesca/polygons';
export const GET_COORDS_SNIFA ='/snifa'

// SPED ORIGINAL
export const GET_REGIONS ='/sma/catastro/get-data-region';
export const GET_COMMUNES ='/sma/catastro/get-data-comuna';
export const GET_NEIGHBOURHOODS = '/sma/catastro/get-data-barrios';
export const GET_AREAS = '/sma/catastro/get-data-area';
export const GET_COMPANIES = '/sma/catastro/json/titulares/';
export const GET_ESTABLISHMENTS = '/sma/catastro/json/unidadesFiscalizables/';
export const GET_PRODUCTIVE_CYCLES = '/sma/catastro/json/ciclos-productivos';
export const GET_WEEKLY_REPORT_FAN_DATA = '/monitoreo/json-reporte-semanal-fan'
export const GET_ENVIRONMENTAL_PARAMETER_DATA = '/monitoreo/json/datos-parametro-ambiental'
export const GET_MICROALGAE_NOCIVE_HISTORICAL_DATA = '/monitoreo/dashboard-fan/json/grafico/microalgas-nocivas-encontradas-historico'


